export const ANALYTICS_OPTIONS = {
  GTM_ID: 'GTM-PMDFG9',
  YM_ID: 159737,
};
